/* eslint-disable no-undef */
import { mapState } from 'vuex'

export const mixinExcel = {
  computed: {
    ...mapState({
      selectedRangeAddress: (store) => store.selectedRangeAddress,
    }),
  },

  methods: {
    async rowGetLastInColumn(worksheetName, startCellAddress) {
      var lastRow = 0
      await Excel.run(async function (context) {
        var wSheetName = worksheetName
        var worksheet = context.workbook.worksheets.getItem(wSheetName)
        var startCellRange = worksheet.getRange(startCellAddress)

        startCellRange.load('rowIndex, columnIndex')
        await context.sync()

        var lastRowCell = worksheet
          .getCell(startCellRange.rowIndex, startCellRange.columnIndex)
          .getEntireColumn()
          .getUsedRange(true)
          .getLastCell()
          .load(['rowIndex'])
        await context.sync()

        lastRow = lastRowCell.rowIndex
      })
      return lastRow + 1
    },
  },
}
